// extracted by mini-css-extract-plugin
export default {"tabBar":"tabBar_tabBar__TKVmE","active":"tabBar_active__rN-3m","badge":"tabBar_badge__bxgNR"};